"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = require("@osmosys/react");
const react_2 = tslib_1.__importStar(require("react"));
const react_monaco_editor_1 = tslib_1.__importDefault(require("react-monaco-editor"));
const template_parser_1 = require("@osmosys/template-parser");
const graphql_1 = require("../../../../graphql");
const react_hooks_1 = require("@apollo/react-hooks");
const reactstrap_1 = require("reactstrap");
const DeployButton_1 = require("../../../../routes/Private/EmailTemplateDetail/DeployButton");
const react_use_1 = require("react-use");
const react_hanger_1 = require("react-hanger");
const hooks_1 = require("../../hooks");
const NewEmailView_1 = require("../../../../routes/Private/Emails/EmailHome/NewEmailView");
const hooks_2 = require("../../../../hooks");
const EmailCanvasCodeModeSaveButton = () => {
    const { data: { draftEmail: draft, sourceEmail: source }, } = hooks_1.useEmailCanvasCanvas('state');
    const sourceHtml = source.originalHTML;
    const draftHtml = draft.originalHTML;
    const [version, setVersion] = react_2.useState();
    const queryResult = react_hooks_1.useQuery(graphql_1.suggestNextVersion, {
        variables: { version: draft.emailTemplateVersion.version },
    });
    const { mutate, result } = hooks_2.useCreateEmailTemplateVersion({
        emailTemplateId: draft.emailTemplateVersion.template.id,
        html: draftHtml,
        version,
    });
    const newVersion = draft.emailTemplateVersion.template.suggestedNextVersion ||
        (queryResult.data && queryResult.data.suggestNextVersion) ||
        '1.0.0-beta.1';
    react_2.useEffect(() => {
        setVersion(newVersion);
    }, [newVersion]);
    const [isOpen, toggle] = react_use_1.useToggle(false);
    const prevResultData = react_hanger_1.usePrevious(result.data);
    react_2.useEffect(() => {
        if (!prevResultData && result.data) {
            toggle(true);
        }
    }, [prevResultData, result, toggle]);
    return (react_2.default.createElement(react_2.default.Fragment, null,
        react_2.default.createElement(exports.EmailCanvasCodeModeVersionInput, { version: version, setVersion: setVersion }),
        react_2.default.createElement(react_1.OsmosysFlexFrame.ToolbarButton, { mutationResult: result, mutate: mutate, osysName: "Save", osysIcon: "save", disabled: sourceHtml === draftHtml, osysStyle: "default", color: "success", renderApolloError: true },
            react_2.default.createElement("div", { className: "d-inline-block" },
                "Save as ",
                version)),
        ' ',
        react_2.default.createElement(EmailCanvasDeployTemplateVersionModal, { isOpen: isOpen, toggle: () => toggle(false), emailTemplateVersion: result.data && result.data.createEmailTemplateVersion, emailTemplate: draft.emailTemplateVersion.template })));
};
const EmailCanvasDeployTemplateVersionModal = ({ isOpen, toggle, emailTemplateVersion, emailTemplate }) => {
    return (react_2.default.createElement(react_1.OsmosysModal, { isOpen: isOpen, toggle: () => {
            toggle(false);
        }, centered: true },
        react_2.default.createElement(react_1.OsmosysModal.Body, { className: "text-center" },
            react_2.default.createElement("div", { className: "my-2" },
                react_2.default.createElement(DeployButton_1.DeployButton, { emailTemplate: emailTemplate, emailTemplateVersion: emailTemplateVersion, onCompleted: () => { } })),
            react_2.default.createElement("div", { className: "my-2" },
                react_2.default.createElement(NewEmailView_1.NewEmailView, { template: emailTemplate, templateVersion: emailTemplateVersion })))));
};
const EmailCanvasCodeModeSize = () => {
    const { dispatchCanvasAction } = hooks_1.useEmailCanvasUpdate();
    const { prefs: { codeModeSize }, } = hooks_1.useEmailCanvasContext();
    const nextSize = codeModeSize === 'sm' ? 'md' : codeModeSize === 'lg' ? 'sm' : 'lg';
    return (react_2.default.createElement(react_1.OsmosysFlexFrame.ToolbarButton, { size: "sm", osysName: "Size", onClick: () => {
            dispatchCanvasAction({
                data: {
                    codeModeSize: nextSize,
                },
                type: 'prefs',
            });
        }, tooltip: `Switch to ${nextSize.toUpperCase()}` }, codeModeSize.toUpperCase()));
};
exports.EmailCanvasCodeModeVersionInput = ({ version, setVersion }) => {
    return (react_2.default.createElement(react_1.OsmosysFlexFrame.ToolbarCell, { osysName: "EmailCanvasCodeModeVersionInput", flexColCentered: true },
        react_2.default.createElement(reactstrap_1.Input, { value: version || '', onChange: e => setVersion(e.target.value), bsSize: "sm", className: "border-0 mr-2 p-0 text-right", style: { width: 70 } }),
        ' '));
};
exports.EmailCanvasCodeModePanel = () => {
    const { dispatchCanvasAction } = hooks_1.useEmailCanvasUpdate();
    const { state: { draftEmail: draft }, prefs: { codeModeSize }, } = hooks_1.useEmailCanvasContext();
    const pixelDiff = codeModeSize === 'sm' ? -50 : codeModeSize === 'lg' ? 50 : 0;
    const draftHtml = draft.originalHTML;
    const [html, setHtml] = react_2.useState(draftHtml);
    const usePortal = false;
    react_use_1.useDebounce(() => {
        const [parsed, newHtml,] = new template_parser_1.BlueprintTemplateParser().parseHtmlDocumentString(html);
        dispatchCanvasAction({
            data: {
                draftEmail: Object.assign(Object.assign({}, draft), { blocks: parsed, html: newHtml, originalHTML: html }),
            },
            type: 'state',
        });
    }, 1000, [html]);
    const comp = (react_2.default.createElement(react_1.OsmosysFlexFrame, { osysName: "codeMode.outer", bg: "white", borderTop: true, shadow: true, style: { maxHeight: 340 + pixelDiff } },
        react_2.default.createElement(EmailCanvasCodeModePanelToolbar, null),
        react_2.default.createElement(react_1.OsmosysFlexFrame.Row, { osysName: "codeMode.inner", style: { height: 300 + pixelDiff, width: '100%' } },
            react_2.default.createElement(react_monaco_editor_1.default, { value: html, onChange: newVal => {
                    setHtml(newVal);
                } }))));
    if (usePortal) {
        return react_2.default.createElement(react_1.Portal, { elementID: "footer-portal" }, comp);
    }
    return comp;
};
const EmailCanvasCodeModePanelToolbar = () => {
    const { state: { draftEmail: draft }, } = hooks_1.useEmailCanvasContext();
    return (react_2.default.createElement(react_1.OsmosysFlexFrame.Row, { osysName: "codeMode.inner flex-shrink-0", style: { width: '100%' } },
        react_2.default.createElement(react_1.OsmosysFlexFrame.ToolbarGroup, { osysName: "codeMode.groupLeft" },
            react_2.default.createElement(react_1.OsmosysFlexFrame.ToolbarCell, { osysName: "emailTemplateVersion", padding: "sm", className: "text-muted", flexColCenteredFilled: true },
                react_2.default.createElement("div", { className: "" },
                    "Editing",
                    ' ',
                    draft.emailTemplateVersion && draft.emailTemplateVersion.version)),
            react_2.default.createElement(EmailCanvasCodeModeSize, null)),
        react_2.default.createElement(react_1.OsmosysFlexFrame.ToolbarGroup, { osysName: "filler", flexFill: true }),
        react_2.default.createElement(react_1.OsmosysFlexFrame.ToolbarGroup, { osysName: "codeMode.save" },
            react_2.default.createElement(EmailCanvasCodeModeSaveButton, null))));
};
//# sourceMappingURL=index.js.map